module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Incidente.46baf39c.svg";